import { imageProvider } from './config/imageProvider/imageProviderConfig';
import { redirect } from './redirect';

const version = new Date().getTime();
export const BASE_URL = process.env.BASE_API_URL;
export const BASE_API_URL = `${BASE_URL}/api/`;
// eslint-disable-next-line max-len,vue/max-len
export const CONF_TOKEN = 'a26ac89e14e68c5f8f1e1246622b88ec83774411009035bbd95e614acebf9f553EuOp-e0m40lWWyqx8T7ZW6ToSLUFnVf';

export default {
  modern: process.env.ENVIRONMENT === 'production',
  server: {
    port: 3100,
    // host: '0.0.0.0',
  },
  // Global page headers: https://go.nuxtjs.dev/config-head
  head: {
    title: 'Транспортная компания в  - Central Trans',
    htmlAttrs: {
      lang: 'ru',
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { hid: 'metadescription', name: 'description', content: '' },
    ],
    link: [
      { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
      { rel: 'stylesheet', href: 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css' },
    ],
    script: [
      {type: 'text/javascript', body: true, src: '/js/sourcebuster.min.js', async: true},
      {type: 'text/javascript', body: false, src: 'https://widget.novofon.ru/novofon.js?k=dqgTo_Akr6eLuRcI9HyXKyp_iU8BBhOH', async: true},
    ],
  },

  // Global CSS: https://go.nuxtjs.dev/config-css
  css: [
    '~/static/fonts/fonts.scss',
    '~/assets/scss/main.scss'
  ],
  serverMiddleware: [
    '~/server-middleware/cache-handler',
  ],
  // Plugins to run before rendering page: https://go.nuxtjs.dev/config-plugins
  plugins: [
    { src: '~/plugins/Vuelidate.js' },
    { src: '~plugins/vue-range-slider.js', ssr: false },
    { src: '~plugins/fancyapps-ui.js', ssr: false },

    '~plugins/vue-mask.js',
    '~plugins/phone-format.js',
    '~plugins/number-format.js',
    '~plugins/case-words.js',
    '~plugins/get-cookies-opt.js',
    '~plugins/device.js',
    '~plugins/additional-block-classes.js',
    '~plugins/yaglaaction.js',
    '~plugins/checkRoutes.js'
  ],

  // Build Configuration: https://go.nuxtjs.dev/config-build

  // Modules for dev and build (recommended): https://go.nuxtjs.dev/config-modules
  buildModules: [

    // https://go.nuxtjs.dev/typescript
    '@nuxt/typescript-build',
    '@nuxtjs/google-analytics',
  ],
  // Modules: https://go.nuxtjs.dev/config-modules
  modules: [
    'cookie-universal-nuxt',
    '@nuxt/image',
    '@nuxtjs/style-resources',
    '@nuxtjs/toast',
    ['~/node_modules/sitis-nuxt/lib', {
      baseUrl: BASE_API_URL,
      // cmsRoot: 'cms' - default
    }],

    // Yandex Metrika
    [
      '@rkaliev/nuxtjs-yandex-metrika',
      {
        debug: false,

        id: 34965765,
        webvisor: true,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        ecommerce: 'dataLayer',
        disabled: Boolean(process.env.ENVIRONMENT !== 'production'),
      },
    ],

    ['@nuxtjs/redirect-module', { statusCode: 301 }],

    // reCAPTCHA
    ['@nuxtjs/recaptcha', {
      language: "ru",
      siteKey: "6Le1miUqAAAAAOFRe3tbV_Hf5xqAhcRTAFsevPXn",
      version: 2
    }],
  ],
  image: imageProvider(BASE_API_URL),
  // '@nuxtjs/toast' config
  toast: {
    position: 'top-right',
    duration: 3000,
  },
  components: false,

  render: {
    bundleRenderer: {
      shouldPreload: (file, type) => ['font', 'script', 'style'].includes(type),
    },
  },
  build: {
    extend(config, { isClient }) {
      // Extend only webpack config for client-bundle

      if (isClient) {
        config.devtool = 'source-map';
      }
    },
    filenames: {
      img: `[path][name].[ext]?v=${version}`,
      app: `[name].modern.js?v=${version}`,
      chunk: `[name].modern.js?v=${version}`,
      font: '[path][name].[ext]',
      css: `[name].css?v=${version}`,
    },
    extractCSS: true,
    optimization: {
      runtimeChunk: 'single',
      splitChunks: {
        chunks: 'all',

        maxInitialRequests: Infinity,
        minSize: 0,
        cacheGroups: {
          vendor: {
            test: /[\\/]node_modules[\\/]/,
            name(module) {
              const packageName = module.context.match(/[\\/]node_modules[\\/](.*?)([\\/]|$)/)[1];
              return `npm.${packageName.replace('@', '')}`;
            },
          },
        },
      },
    },
  },

  router: {
    extendRoutes(routes, resolve) {
      // Посадчные страницы по городам
      routes.unshift({
        path: '/ural/:slug',
        components: {
          default: resolve(__dirname, 'pages/cargo-landing/_.vue'),
        },
        chunkNames: {
          default: 'cargo-landing-ural',
        },
      });

      routes = routes.sort((a, b) => {
        if (a.path < b.path) {
          return 1;
        }
        if (a.path > b.path) {
          return -1;
        }
        return 0;
      });
    },
  },
  env: {
    baseApiUrl: process?.env?.BASE_API_URL,
    pageAliasPolicy: process.env?.PAGE_ALIAS_POLICY || '/policy',
    cmsPageIdHowWorkBlock: process?.env?.CMS_PAGE_ID_HOW_WORK_BLOCK || '294',
    cmsPageIdOurExperinceBlock: process?.env?.CMS_PAGE_ID_OUR_EXPERIENCE_ID || '295',
    yandexApiKey: process.env?.YANDEX_API_KEY || 'e86ae4b7-8768-47e6-8b40-e3fd437c508a',
    freightPriceMultiplier: process?.env?.FREIGHT_PRICE_MULTIPLE || '0.1',
    baseCookieDomain: process.env.BASE_COOKIE_DOMAIN,

    cmsPageIdGruzopodemnost: process.env.CMS_PAGE_ID_GRUZOPODEMNOST || '163',
    cmsPageIdOtrasli: process.env.CMS_PAGE_ID_OTRASLI || '162',
    cmsPageIdTipGruza: process.env.CMS_PAGE_ID_TIP_GRUZA || '161',

    transportationApiUrl: process.env.TRANSPORTATION_API_URL,
    transportationSiteUrl: process.env.TRANSPORTATION_SITE_URL,
  },

  // googleAnalytics: {
  //   id: process.env.GOOGLE_ANALYTICS_ID || 'UA-22235063-11',
  //   dev: Boolean(process.env.ENVIRONMENT !== 'production'),
  // },

  redirect,
};
